module.exports = __webpack_public_path__ + "static/media/to.1b08a37e.svg";